"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

require("./index.css");

var Checkbox = function (_a) {
  var label = _a.label,
      id = _a.id,
      dataTestId = _a.dataTestId,
      selected = _a.selected,
      indeterminate = _a.indeterminate,
      props = __rest(_a, ["label", "id", "dataTestId", "selected", "indeterminate"]);

  var checkboxRef = (0, react_1.useRef)();
  var checkboxClasses = 'ui-checkbox';
  if (props.checked) checkboxClasses += ' ui-checkbox-checked';
  (0, react_1.useLayoutEffect)(function () {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  return (0, jsx_runtime_1.jsxs)("label", __assign({
    htmlFor: id,
    className: checkboxClasses
  }, {
    children: [(0, jsx_runtime_1.jsx)("input", __assign({
      className: "checkbox",
      type: "checkbox",
      id: id,
      name: id,
      "data-testid": dataTestId,
      defaultChecked: selected,
      ref: checkboxRef
    }, props), void 0), (0, jsx_runtime_1.jsx)("span", __assign({
      className: "checkbox-label-text"
    }, {
      children: label
    }), void 0)]
  }), void 0);
};

Checkbox.propTypes = {
  id: prop_types_1.string.isRequired,
  label: prop_types_1.string,
  dataTestId: prop_types_1.string,
  selected: prop_types_1.bool,
  indeterminate: prop_types_1.bool
};
Checkbox.defaultProps = {
  label: '',
  dataTestId: 'generic-checkbox',
  indeterminate: false
};
exports.default = Checkbox;